export const tokens = {
  rewardToken: {
    token: "KYOKO",
    address: "0x14a32f050FACF226Ec60882398A9BF36d91DBaC2",
    decimals: 18,
  },
};
